import { useFormContext, useWatch } from 'react-hook-form';
import { EventPanelFormType } from '@mark43/cad-api';

export function EventPanelFormArrayCount({ name }: { name: keyof EventPanelFormType }) {
    const form = useFormContext<EventPanelFormType>();
    const value = useWatch({ control: form.control, name });
    return <>{Array.isArray(value) ? value.length : 0}</>;
}
